// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023carrot/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (page: number, workType: string, search?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search,
      workType,
    },
  });
};

const getDetail = (id: string | number) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getRank = (type: number, page: number) => {
  return http.get(`${urlPrefix}rank&type=${type}&page=${page}`);
};

const getAreas = () => {
  return http.get(`${urlPrefix}getAreas`);
};
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getNewsList = (classId: string, page: number | string) => {
  return http.get(`/vote/public/controller.php?enews=news-list`, {
    params: {
      classId,
      page,
    },
  });
};
// 获取兄弟id
const getSiblingId = (id: string | number) => {
  return http.get(`${urlPrefix}prizeNextLastId`, {
    params: {
      number: id,
    },
  });
};

// 获取评审列表数据
const getPrizeList = (page: number, search = '', workType = 1) => {
  return http.get(`${urlPrefix}prize-list`, {
    params: {
      page,
      search,
      workType,
    },
  });
};

// 获取评审模式下的详情数据
const getPrizeDetail = (id: string | number) => {
  return http.get(`${urlPrefix}prize-detail`, {
    params: {
      id,
    },
  });
};

interface IRegister {
  name: string;
  school: string;
  class: string;
  county: string | number;
  teacher: string;
  recite: string;
  introduction: string;
  cover: string;
  video: string;
}
const register = (data: IRegister) => {
  return http.post(`${urlPrefix}save-web`, qs.stringify(data));
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

// rank vote-list detail save getAreas rules
const getUserList = (data: any) => {
  return http.get(`${urlPrefix}vote-list-user`, {
    params: {
      ...data,
    },
  });
};
export {
  getBaseInfo,
  getVoteList,
  getDetail,
  getAreas,
  register,
  getRank,
  getRule,
  getNewsList,
  getSiblingId,
  getPrizeList,
  getPrizeDetail,
  getNews,
  getUserList,
};
